import { RecipeDetailResponse } from '@diamond/shared/types';
import { buyerCurrencyFormatter } from '@diamond/shared/utils';
import { handleCogSummary } from '@diamond/sol-buyer/utils';
import { useMemo, useState } from 'react';

type UseRecipeDetailOpts = {
  data: RecipeDetailResponse;
  isAuthenticated: boolean;
};

export function useRecipeDetail({
  data,
  isAuthenticated,
}: UseRecipeDetailOpts) {
  const hasRecommendedProducts = useMemo(
    () =>
      data.ingredient_groups.some((ig) =>
        ig.ingredients.some((e) => e.recommended_products.length > 0)
      ),
    [data.ingredient_groups]
  );

  const hasAlternativeProducts = useMemo(
    () =>
      data.ingredient_groups.some((ig) =>
        ig.ingredients.some((e) => e.alternative_products.length > 0)
      ),
    [data.ingredient_groups]
  );

  const [isRecommended, setRecommended] = useState<boolean>(() => {
    return hasRecommendedProducts || !hasAlternativeProducts;
  });

  const alternativeData = data.ingredient_groups.flatMap((item) =>
    item.ingredients.flatMap((ingredient) => ingredient.alternative_products)
  );
  const recomendedData = data.ingredient_groups.flatMap((item) =>
    item.ingredients.flatMap((ingredient) => ingredient.recommended_products)
  );

  const getHppPrice = () => {
    if (!isAuthenticated) return 'Rp. xxx.xxx';
    if (isRecommended) {
      return buyerCurrencyFormatter(handleCogSummary(recomendedData, true));
    }
    return buyerCurrencyFormatter(handleCogSummary(alternativeData, true));
  };

  const countCartItems = () => {
    return isRecommended
      ? handleCogSummary(recomendedData, false)
      : handleCogSummary(alternativeData, false);
  };

  return {
    getHppPrice,
    countCartItems,
    isRecommended,
    setRecommended,
    hasAlternativeProducts,
    hasRecommendedProducts,
  };
}
